import { initialState } from './initialState';
import * as constants from './constants';
import produce from 'immer';

// ===========================|| ACCOUNT REDUCER ||=========================== //

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_ROD_TABLE:
      return produce(state, (draft) => {
        const tableData = action.payload;
        draft.rodCatalogTableData = tableData;
      });
    case constants.INIT_PROJECTS:
      return produce(state, (draft) => {
        const projects = action.payload;
        draft.projectIds = [];
        draft.projectsById = {};
        projects.forEach((project, idx) => {
          const { id } = project;
          draft.projectsById[id] = project;
          draft.projectIds.push(id);
          // Select the first project
          if (idx === 0) {
            draft.selectedProjectIds = [id];
          }
        });
      });

    case constants.SELECT_PROJECTS:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedProjectIds = ids;
      });

    case constants.ADD_PROJECT:
      return produce(state, (draft) => {
        const project = action.payload;
        const { id } = project;
        draft.projectsById[id] = project;
        draft.projectIds.push(id);
        // Insert new case to select
        draft.selectedProjectIds.unshift(id);
      });

    case constants.REMOVE_PROJECT:
      return produce(state, (draft) => {
        const id = action.payload;
        // Delete in obj
        delete draft.projectsById[id];
        // Delete in order array
        const idx = draft.projectIds.findIndex((projectId) => projectId === id);
        if (idx !== -1) draft.projectIds.splice(idx, 1);
        // Delete in selectedProjectIds
        const selectId = draft.selectedProjectIds.findIndex((projectId) => projectId === id);
        if (selectId !== -1) draft.selectedProjectIds.splice(selectId, 1);
      });

    case constants.UPDATE_PROJECT:
      return produce(state, (draft) => {
        const { id } = action.payload;
        draft.projectsById[id] = action.payload;
      });

    case constants.UPDATE_PROFIT_CALC_INPUT:
      return produce(state, (draft) => {
        const { key, value } = action.payload;
        draft.profitCalcInput[key] = value;
      });

    case constants.INIT_SENSITIVITIES:
      return produce(state, (draft) => {
        const sensitivites = action.payload;
        draft.sensitivityIds = [];
        draft.sensitivitiesById = {};
        draft.selectedSensitivityIds = [];
        sensitivites.forEach((sensitivity) => {
          const { id } = sensitivity;
          draft.sensitivitiesById[id] = sensitivity;
          draft.sensitivityIds.push(id);
        });
      });
    case constants.CLEAR_SENSITIVITIES:
      return produce(state, (draft) => {
        draft.sensitivityIds = [];
        draft.sensitivitiesById = {};
        draft.selectedSensitivityIds = [];
      });

    case constants.SELECT_SENSITIVITIES:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedSensitivityIds = ids;
        draft.selectedScenarioIds = [];
      });

    case constants.ADD_SENSITIVITY:
      return produce(state, (draft) => {
        const { id } = action.payload;
        draft.sensitivitiesById[id] = action.payload;
        draft.sensitivityIds.push(id);
        draft.selectedSensitivityIds = [id];
      });

    case constants.REMOVE_SENSITIVITY:
      return produce(state, (draft) => {
        const id = action.payload;
        // Delete in obj
        delete draft.sensitivitiesById[id];
        // Delete in order array
        const idx = draft.sensitivityIds.findIndex((sensitivityId) => sensitivityId === id);
        if (idx !== -1) draft.sensitivityIds.splice(idx, 1);
        // Delete in selectedProjectIds
        const selectId = draft.selectedSensitivityIds.findIndex((sensitivityId) => sensitivityId === id);
        if (selectId !== -1) draft.selectedSensitivityIds.splice(selectId, 1);
      });

    case constants.UPDATE_SENSITIVITY:
      return produce(state, (draft) => {
        const { id } = action.payload;
        draft.sensitivitiesById[id] = action.payload;
      });

    case constants.SELECT_SCENARIOS:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedScenarioIds = ids;
      });

    case constants.SELECT_CURRENT_LAYOUT:
      return produce(state, (draft) => {
        const currentLayout = action.payload;
        draft.currentLayout = currentLayout;
      });

    case constants.UPDATE_SETTINGS:
      return produce(state, (draft) => {
        const settings = action.payload;
        draft.settings = settings;
      });

    default:
      return state;
  }
};

export default reducer;
